import ExpandedDetails from "./ExpandedDetails";
export default ExpandedDetails;
